import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dynamic_currency_conversion = _resolveComponent("dynamic-currency-conversion")

  return ($options.isDccVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_dynamic_currency_conversion, {
          "project-id": $props.projectId,
          "order-id": $props.orderId,
          "order-code": $props.orderCode,
          reason: $props.reason,
          "handle-tax-without-shipping": $props.handleTaxWithoutShipping,
          "can-be-paid-in-installments": $props.canBePaidInInstallments,
          "payment-currency-strategy": $props.paymentCurrencyStrategy,
          "order-code-for-installment-calculation": $props.orderCodeForInstallmentCalculation
        }, null, 8 /* PROPS */, ["project-id", "order-id", "order-code", "reason", "handle-tax-without-shipping", "can-be-paid-in-installments", "payment-currency-strategy", "order-code-for-installment-calculation"])
      ]))
    : _createCommentVNode("v-if", true)
}